/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 */

export const msalConfig = {
    auth: {
        clientId: process.env.APP_CLIENTID ? process.env.APP_CLIENTID : process.env.REACT_APP_CLIENTID, // This is the ONLY mandatory field that you need to supply.
        authority: process.env.REACT_APP_AUTHORITY, // Replace the placeholder with your tenant subdomain 
        redirectUri: process.env.REACT_APP_REDIRECT_URL, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: '/LogOut', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
        responseType : ['code','id_token'],
        responseMode: 'form_post'

    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    requestPermissionScope:{

    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    //scopes: [...protectedResources.toDoListAPI.scopes.read, ...protectedResources.toDoListAPI.scopes.write],
    //scopes: ["user.read","openid","Sites.Read.All","Files.Read.All","GroupMember.Read.All"],
    scopes: [process.env.REACT_APP_USER_READ,process.env.REACT_APP_OPENID,process.env.REACT_APP_PROFILE,process.env.REACT_APP_EMAIL,process.env.REACT_APP_SITES_READ_ALL,process.env.REACT_APP_FILES_READ_ALL],
};

export const graphConfig= {
    graphMeEndpoint : "https//:graph.microsoft.com/v1.0/me"

}
